(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  class CardSelector {
    constructor(selector) {
      this.el = document.querySelector(selector);
      this.el.classList = "";
      this.imageEls = this.el.querySelectorAll(`[data-sk-card-image-icon]`);
      this.dataEl = this.el.querySelector(`#requested-card`);
      this.outerEl = this.el.querySelector(`[data-sk-outer]`);
      this.innerEl = this.el.querySelector(`[data-sk-inner]`);
      this.ccEls = this.el.querySelectorAll("[data-sk-cc]");
      this.messageEl = this.el.querySelector(`#card-message`);
      this.questionElYes = this.el.querySelector("#yes")
      this.questionElNo = this.el.querySelector("#no")
      this.cardWidgetEl = this.el.querySelector("[data-sk-card-widget]")
      this.data = {};
      this._bind();
    }

    _bind() {
      console.log("here")
      this._bindCardSelection()
      this._bindNote()
      this._bindQuestion()
    }
    
    _bindCardSelection() {
      let cs = this
      for (let i = 0; i < this.imageEls.length; i++) {
        this.imageEls[i].addEventListener("click", function(event) {
          const el = event.currentTarget;
          const img = el.querySelector(`img`)

          // Select the correct image
          cs.el.querySelectorAll(`.selected`).forEach(e => e.classList.remove("selected"))
          img.classList.add('selected');

          // change the data
          cs.data.template = el.getAttribute("data-sk-card-template")
          cs._updateData()

          //modify the outer
          cs.ccEls.forEach(e => e.classList.add("hidden"))
          cs.el.querySelectorAll(`[data-sk-cc=${cs.data.template}]`).forEach(e => e.classList.remove("hidden"));

          // Add selected Class
          img.classList.add('selected');
        });
      }
    }
    
    _bindNote() {
      let cs = this
      this.messageEl.addEventListener("input", function(event) {
        cs.data.message = event.currentTarget.value;
        cs._updateData()
      });
    }
    _cardState(checked) {
        if (checked) {
          this.cardWidgetEl.classList.remove("hidden")
          this._updateData()
        } else {
          this.cardWidgetEl.classList.add("hidden")
          this.dataEl.value = null
        }
    }
    _bindQuestion() {
      let cs = this
      this.questionElYes.addEventListener("change", function(event) {
        cs._cardState(this.checked)
        if (!cs.data.template){
          console.log("click")
          cs.imageEls[0].click()
        }
      });
      this.questionElNo.addEventListener("change", function(event) {
        cs._cardState(!this.checked)
      });
    }

    _updateData() {
      this.dataEl.value = JSON.stringify(this.data)
    }
  }

  if (document.querySelector('[data-gift-card="false"]')) {
    new CardSelector("#card-selector")
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  

  class QKVariantToggle {
    constructor(layer) {
      this.layer = layer;
      this.$els = document.querySelectorAll(`[data-qk-toggle="variant-toggle"][data-qk-layer="${this.layer}"]`);
      this._bind();
    }

    _bind() {
      let self = this;
      document.querySelectorAll("body")[0].addEventListener("update.variant", function(event) {
        self.update(event.detail.variant?.id);
      }); 
    }

    update(variantId) {
      let els = Array.from(this.$els)

      els.forEach(e=> {
        e.classList.add("hidden");
      })
      let defaultEl = els.filter(e=> {
        return e.dataset.qkVariant == "default"
      })
      let foundEl = els.filter(e=> {
        return e.dataset.qkVariant == variantId
      })
      if (foundEl.length) {
        let el = foundEl[0];
        if (el.innerHTML.trim() !== "") {
          foundEl[0].classList.remove("hidden");
        } else {
          defaultEl[0].classList.remove("hidden");
        }
      } else {
        defaultEl[0].classList.remove("hidden");
      }
    }
  }
  
  // Loop through each element and create a new instance of QKVariantToggle
  document.querySelectorAll('[data-qk-toggle="variant-toggle"][data-qk-variant="default"][data-qk-layer]').forEach(function(element) {
    const layer = element.getAttribute("data-qk-layer");
    new QKVariantToggle(layer);
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

     let r = new theme.peekCarouselSplide(productRecommendationsSection);
    console.log(r)
      
      // theme.peekCarousel.init(
      //   productRecommendationsSection,
      //   $('.js-related-product-carousel', productRecommendationsSection),
      //   '.productRecommendations',
      //   function() {
      //     return $(window).width() < 768
      //   },
      //   false
      // );
      // theme.initUniformHeightMonitor(productRecommendationsSection, '.product-block__image-container', '.product-block__image-container .image-one');
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  // if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
  //   theme.destroyUniformHeightMonitor($('.product-recommendations', event.target));
  //   theme.peekCarousel.destroy(
  //     $('.product-recommendations', event.target),
  //     $('.js-related-product-carousel', event.target),
  //     '.productRecommendations'
  //   );
  // }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qk-podcast-home"] && !Shopify.designMode) return;
  try {
    

(() => {
    const podcasts = document.querySelectorAll(`[data-qk-toggle="podcast"]`)
    const slider = document.getElementById('slider');
    let selectedAOG = "-1";

    const labels = {
        [-1]: { full: "Pre-Birth", short: "Pre-Birth" },
        0:  { full: "New Born", short: "New Born" },
        1:  { full: "1 Year", short: "1" },
        2:  { full: "2 Years", short: "2" },
        3:  { full: "3 Years", short: "3" },
        4:  { full: "4 Years", short: "4" },
        5:  { full: "5 Years", short: "5" },
        6:  { full: "6+ Years", short: "6+" }
    };

    noUiSlider.create(slider, {
    start: [1, 3],        // initial values
    connect: true,
    range: {
        min: -1,
        max: 6
    },
    step: 1,
    pips: {
        mode: 'values',
        values: [-1, 0, 1, 2, 3, 4, 5, 6],
        density: 100,
        format: {
        to: function (value) {
            return labels[value]?.full ?? value;
        }
        }
    }
    });

    const minVal = document.getElementById('min-val');
    const maxVal = document.getElementById('max-val');
    const toVal = document.getElementById('to-val');
    let _minAge = 0
    let _maxAge = 0

    slider.noUiSlider.on('update', (values) => {
        _minAge = Math.round(values[0])
        _maxAge = Math.round(values[1])
        if (_minAge === _maxAge) {
            minVal.textContent=""
            toVal.style.display = "none";
            maxVal.textContent = (labels[_maxAge]?.full);
        } else {
            toVal.style.display = "initial";
            minVal.textContent = (labels[_minAge]?.short);
            maxVal.textContent = (labels[_maxAge]?.full);
        }
        render();
    });

    

    document.querySelectorAll(".aog-btn").forEach(btn => {
        btn.addEventListener("click", () => {
            document.querySelectorAll(".aog-btn").forEach(b => b.classList.remove("active"));
            btn.classList.add("active");

            selectedAOG = btn.dataset.value;

            // later: plug into your filtering logic
            render();
        });
    });

    

    function render() {
        podcasts.forEach(p => {
            const minAge = p.dataset.qkMinAge;
            const maxAge = p.dataset.qkMaxAge;
            const aogs = p.dataset.qkAogs;

            let shown = true;

            if (maxAge < _minAge || minAge > _maxAge) {
                shown = false
            }
            if (selectedAOG != "-1" && !aogs.includes(selectedAOG)) {
                shown = false;
            }
            p.style.display = shown ? "initial" : "none"
        })
    }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qk-podcast"] && !Shopify.designMode) return;
  try {
    

  let player;

  class TimeStamp {
    constructor(el, videoEl) {
      this.el = el;
      this.video = videoEl;
      this.time = parseInt(this.el.dataset.qkSeconds, 10);
      this.button = this.el.querySelector("a");
      console.log(this)

      this.bind();
    }

    bind() {
      this.button.addEventListener("click", (e) => {
        console.log("here")
        e.preventDefault();

        if (this.video && !isNaN(this.time)) {

          const url = new URL(this.video.src);
          url.searchParams.set("start", this.time);
          url.searchParams.set("autoplay", "1");
          this.video.src = url.toString();
          this.video.scrollIntoView()
        }
      });
    }
  }

  document.querySelectorAll('[data-qk-toggle="timestamp"]').forEach((el) => {
    new TimeStamp(el, document.getElementById("pod-iframe"));
  });


  } catch(e) { console.error(e); }
})();
})();
